export const unitLabel = {
  l: 'L',
  kg: 'Kg',
  unit: 'pièce',
  t: 'T',
  q: 'q',
  piece: 'pièce',
  linear_meter: 'mètre linéaire',
  ml: 'mL',
  lb: 'lb',
  oz: 'oz',
  gal: 'gal',
  ha: 'ha',
}

export default function measureUnit(unit) {
  return (unit && (unitLabel[unit] || unit.charAt(0).toUpperCase() + unit.slice(1))) || ''
}
